import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    DELETE_SCHEDULE_TIME_SLOT,
    deleteScheduleTimeSlotFail,
    deleteScheduleTimeSlotSuccess
} from '../action/deleteScheduleTimeSlotAction'

// api 
import deleteScheduleTimeSlotApi from '../api/deleteScheduleTimeSlotApi'

export function* deleteScheduleTimeSlotSaga(action) {
    try {
        const response = yield call(() => deleteScheduleTimeSlotApi(action.params))
        if (response.data.status === 1) {
            yield put(deleteScheduleTimeSlotSuccess(response, action))
        } else {
            yield put(deleteScheduleTimeSlotFail(response, action))
        }
    }
    catch (e) {
        yield put(deleteScheduleTimeSlotFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(DELETE_SCHEDULE_TIME_SLOT, deleteScheduleTimeSlotSaga)
}